import * as React from "react";
import {RouteComponentProps} from "react-router";
import {observer} from "mobx-react";
import AddressRequestEdit from "./PersonAwardsDegreesRequestEdit";
import PersonAwardsDegreesRequestEdit from "./PersonAwardsDegreesRequestEdit";

type Props = RouteComponentProps<{ entityId: string, addressId?: string }>;

@observer
export class PersonAwardsDegreesRequestManagement extends React.Component<Props> {
  static PATH = "/personAwardsDegreesRequest";
  static NEW_SUBPATH = "new";

  render() {
    const {entityId, addressId} = this.props.match.params;
    return (
      <>
        <PersonAwardsDegreesRequestEdit entityId={entityId} addressId={addressId}/>
      </>
    );
  }
}
